import { Component, OnDestroy, SimpleChanges, OnChanges, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Output, Pipe, PipeTransform, EventEmitter, ViewEncapsulation, NgZone } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location, DatePipe } from '@angular/common'
import { Subject, Observable, Subscription, forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { trigger, state, style, transition, animate, animation } from '@angular/animations';
import { CustomerService } from '../../services/customer.service';
import { OrdersService } from '../../services/orders.service';
import { InventoryService } from '../../services/inventory.service';
import { CouponService } from '../../services/coupon.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { DEFAULT_SALESMAN_ALLOWED } from '../../classes/default-salesman-allowed';
import { GlobalsService } from '../../services/globals.service';
import { UsersService } from '../../services/users.service';
import { PurchasingService } from '../../services/purchasing.service';
import { PaymentsService } from '../../services/payments.service';
import { OmsService } from '../../services/oms.service';
import { DispatchService } from 'app/services/dispatch.service';

@Component({
	selector: 'app-shared-order-entry',
	templateUrl: './shared-order-entry.component.html',
	styleUrls: ['./shared-order-entry.component.scss'],
	//encapsulation: ViewEncapsulation.Emulated,
	//encapsulation: ViewEncapsulation.None,
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotateY(-179deg)'
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			transition('inactive => active', animate('300ms ease-in')),
			transition('active => inactive', animate('300ms ease-out')),
		]),
		trigger('cinfo', [
			transition(':enter', [
				animate('50ms', style({ opacity: 1, height: 100 })),
			]),
			transition(':leave', [
				animate('100ms', style({ opacity: 1, height: 0 }))
			]),
		]),
		trigger('itemSearch', [
			transition(':enter', animation([style({ transform: 'translate(-800px,0)', }),
				animate('0.2s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(0)', })
				),
			])),
			transition(':leave', animation([style({ transform: 'translate(0)' }),
				animate('0.15s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(1200px,0)', })
				),
			])),
		]),
		trigger('addFilters', [
			transition(':enter', animation([style({ transform: 'translate(200px,0)', }),
				animate('0.15s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(0)', })
				),
			])),
			transition(':leave', animation([style({ transform: 'translate(0)' }),
				animate('0.15s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(-200px,0)', })
				),
			])),
		]),
		trigger('navIn', [
			transition(':enter', animation([style({ transform: 'translate(200px,0)', }),
				animate('0.10s cubic-bezier(0.59, 0.32, 0.38, 0.33)',
					style({ transform: 'translate(0)', })
				),
			])),
			transition(':leave', animation([style({ transform: 'translate(0)' }),
				animate('0.0s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(-200px,0)', })
				),
			])),
		]),
	],
})
export class SharedOrderEntryComponent implements OnInit, OnChanges {

	@Input() customer: any = false;
	@Input() flip: any = 'inactive';
	@Input() type: any = '10';
	@Input() invoicing: any = false;
	@Input() loadedOrder: any = null;
	@Output() reloadCustomer = new EventEmitter < any > ();
	@Output() customer_updated = new EventEmitter < any > ();

	changeCustomerInput = new UntypedFormControl('');

	CHAT_ROOM = 'OrderBoard';
	sending = false;
	private readonly creditHoldPreSubmitNotice =
		'Over credit limit — order will be placed on credit hold.';
	private readonly creditHoldPostSubmitFallback =
		'Order placed on credit hold (over limit).';
	private lastTpl3plLockNoticeOrderno: string | null = null;
	config: any = [];
	user: any = [];
	cart_items: any = [];
	proceed: any = true;
	total_cart_qty = 0;
	cart_totals: any = [];

	overcredit: any = false;
	allowed_credit: any = true;
	overcredit_override: any = true;
	checkCreditLimits = 0;
	editing_order: any = false;
	order_details: any = false;

	//orderResults: any = false;
	customer_form: any = false;
	vehicle_form: any = false;

	po_vendors: any = [];
	order: any = false;
	created_pos: any = false;
	extra_pos: any = false;
	order_lines: any = false;
	loading_remote = false;
	orderno: any = false;
	remoteqtys: any = [];

	purchase_item: any = false;
	purchordercreated_details: any = false;
	purchasedetails: any = false;
	purchordercreated: any = false;

	baselink: any = '';
	pickingInvoiceLink: any = '';

	orderDetails: any = false;
	orderResults: any = false;
	invoiceResults: any = false;
	inventorysearching: any = false;
	swapitems: any = false;

	anydata = {
		'success': true,
		'orderno': '754076',
		'transno': null,
		'order': '754076',
		'id': null
	};

	adjustment = {
		'additionalcharge': 0.00,
		'additionaltext': ''
	};
	freight_charge: any = 0.00;

	fetchingTotals: any = false;
	fetchingCart: any = false;
	purchase_items: any = [];
	customerdata: any = [];
	//deposits

	payments: any = [];
	payments_added: any = [];
	payment_total = 0.00;
	loadingcards = false;

	preorderDate: any = {
		status: true,
		value: new Date(),
	};

	editsallowed: any = {
		discounts: true,
		editar: true,
		editbilling: true,
		editshipping: true,
		editcontact: true,
		editprofile: true,
		editnotes: true,
		takepayment: true,
	}

	tagalongs: any = false;

	issalesman = false;
	custNotes: any = [];
	totalsshowspinner: any = false;
	worker: Worker;
	@ViewChild('preorderdetails') preorderRef: ElementRef;
	@ViewChild('changeCustomer') changeCustomerRef: ElementRef;
	@ViewChild('assignTracking') assignTrackingRef: ElementRef;
	@ViewChild('paymentDueReminder') paymentDueReminderRef: ElementRef;

	terms: any[] = [];
	paymentDueTermsDescription = '';
	customerNotesSubscription: Subscription | null = null;
	branchupdating: any = false;
	gettingCart: any = false;
	gettingTotals: any = false;
	shippers:any = {
		byid: [],
		byname: []
	}
	showpreauth: any = false;
	preauthorder = false;

	constructor(private ngZone: NgZone, private couponService: CouponService, private dispatchService: DispatchService, private purchasingService: PurchasingService, private inventoryService: InventoryService, private route: ActivatedRoute, private customerService: CustomerService, private orderService: OrdersService, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private globalSearchService: GlobalSearchService, public omsService: OmsService, private fb: UntypedFormBuilder, private modalService: NgbModal, public usersService: UsersService, private paymentsService: PaymentsService, private globalsService: GlobalsService) {

		//private globalsService: GlobalsService,
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		});

		this.globalSearchService.reloadorder.subscribe(r => {
			if (r) {
				this.resetOrder();
			}
		});

		this.baselink = this.config.apiServer.baseUrl + this.config.apiServer.pickingLink;
		this.pickingInvoiceLink = this.config.apiServer.baseUrl + this.config.apiServer.pickingInvoice;

		this.globalSearchService.user.subscribe((results: any) => {
			if (results) {
				this.user = results.user;

				if (results.user.issalesman && this.config.env.package == 'beauty') {
					this.issalesman = true;
					this.editsallowed = this.config.salesmanAllowed ?? DEFAULT_SALESMAN_ALLOWED;
				}
			}
		});

		this.globalsService.getShipVia().subscribe((res) => {
			res.map((shipper)=>{
				let name = shipper.shippername.toLowerCase();
				let id = shipper.shipper_id;
				this.shippers['byid'][id] = name;
				this.shippers['byname'][name] = id;
			})
		});

		this.globalSearchService.terms.subscribe((res: any) => {
			this.terms = Array.isArray(res) ? res : [];
		});

		this.inventoryService.getTagAlongs().subscribe((res) => {
			this.tagalongs = res;
		})

		if (typeof Worker !== 'undefined') {
			this.worker = new Worker(new URL('../../shared-order-entry-totals.worker', import.meta.url), {
				type: 'module',
			});

			this.worker.onmessage = ({ data }) => {
				this.ngZone.run(() => {
					if (data.error) {
						console.error(data.error);
					} else {
						this.cart_totals = data.results;
						this.total_cart_qty = data.total_cart_qty;

						if (!isNaN(this.total_cart_qty)) {
							const hasItems = Array.isArray(this.cart_items) && this.cart_items.length > 0;
							this.flip = this.total_cart_qty !== 0 || hasItems ? this.flip : 'inactive';
						}
						this.checkCreditLimit();
						this.totalsshowspinner = false;
					}
				});
			};
		}
	}

	applyLoadedOrder(results: any): void {
		this.editing_order = true;
		this.order_details = results;
		this.adjustment.additionalcharge = this.order_details.header.additionalcharge || 0;
		this.adjustment.additionaltext = this.order_details.header.additionaltext || '';
		this.customer.preselected = results.preselected;
		this.customer.editingorder = results.header;

		this.fetchingCart = this.orderService.getCart(results.header.debtorno, results.header.branchcode).subscribe((items: any) => {
			this.editing_order = true;
			this.order_details = results;
			this.cart_items = items;
			this.customer.editingorder = results.header;
			this.customer.preselected = results.preselected;
			if (items.length && (!items[0].override || items[0].override === '')) {
				this.proceed = true;
				this.allowed_credit = true;
				this.overcredit_override = items[0].override;
			}
			this.updateTotals();
			this.updatePayments(false);
		});
		this.flip = 'active';
	}

	showInvoiceResultandReset(event: any) {
		//this.invoiceResults = event;
		this.globalSearchService.showNotification('Invoice #' + event.transno + ' Created', 'success', 'bottom', 'left');
		this.resetOrder();
		this.router.navigate(['/orders/success/' + event.id]);
	}

	resetOrder() {

		this.invoicing = false;
		this.sending = false;
		this.orderResults = false;
		this.order_details = false;
		this.editing_order = false;
		this.customer.preselected = false;
		this.customer.dissallowinvoices = false;
		this.clearCart();
		this.updateTotals();

		this.reloadCustomer.emit('cleared');

	}

	updateShipping(value: any) {
		this.freight_charge = value
		this.updateTotals();
	}

	updateAdjust(value: any) {
		this.adjustment.additionalcharge = value.additionalcharge;
		this.adjustment.additionaltext = value.additionaltext;
	}

	updateCustomer(event: any) {
		this.customer_form = event
		if(this.customer.branchcode !== this.customer_form.value.branchcode){
			this.customer.branchcode = this.customer_form.value.branchcode;
		}
	}

	updateVehicle(event: any) {
		this.vehicle_form = event;
	}

	updatePrint(event: any) {
		this.customer_form.doNotPrint = event;
	}
	invoiceOrder(orderno: any) {
		this.invoicing = orderno;
		this.orderResults = false;
	}

	addPromo(promo: any) {
		this.orderService.addPromo(promo, this.customer.debtorno, this.customer.branchcode).subscribe((results: any) => {
			if (results.success) {

				this.cart_items = results.cart;
				this.updateTotals();
				this.globalSearchService.showNotification(results.message, 'success', 'bottom', 'right')

			} else {
				this.globalSearchService.showNotification(results.message, 'danger', 'bottom', 'left');
			}
		});

	}

	addEdu(edu: any) {
		this.orderService.addEdu(edu, this.customer.debtorno, this.customer.branchcode).subscribe((results: any) => {
			if (results.success) {

				this.cart_items = results.cart;
				this.updateTotals();
				this.globalSearchService.showNotification(results.message, 'success', 'bottom', 'right')

			} else {
				this.globalSearchService.showNotification(results.message, 'danger', 'bottom', 'left');
			}
		});
	}



	getLineTotal(item: any): number {
		let qty = parseFloat(item.quantity)
		if (!qty || item.quantity == 0) {
			qty = 1;
		}

		let value: number;
		if (this.config.env.package === 'beauty' || this.config.discounts) {
			value = this.financial(qty) * (this.financial(item.price) - this.financial(this.getItemDiscountMultiplier(item) * item.price));
		} else {
			value = (this.financial(qty) * (this.financial(item.price)) + this.financial(item.fetvalue));
		}

		return value;
	}

	async updateTotals () {
		this.gettingTotals = true;
		if (this.fetchingTotals) {
			this.fetchingTotals.unsubscribe();
		}

		try {
			this.totalsshowspinner = true;

			const results = await this.orderService.getTotals(this.customer.debtorno, this.customer.branchcode, this.freight_charge).toPromise();

			const total_cart_qty = Array.isArray(this.cart_items)
				? this.cart_items.reduce((acc: number, item: any) => acc + (parseFloat(item.quantity) || 0), 0)
				: 0;

			if (this.worker) {
				this.worker.postMessage({
					action: 'calculateTotals',
					payload: { results, cart_items: this.cart_items }
				});
			} else {
				this.ngZone.run(() => {
					this.cart_totals = results || [];
					this.total_cart_qty = total_cart_qty;
					this.totalsshowspinner = false;
					this.gettingTotals = false;
					this.checkCreditLimit();
				});
			}
			this.gettingTotals = false;
		} catch (error) {
			this.ngZone.run(() => {
				this.totalsshowspinner = false;
				this.gettingTotals = false;
			});
		}
	}


	async addItems (items: any) {
		try {
			// Await the async call to addMultipleToOrder
			const results: any = await this.orderService.addMultipleToOrder(items, this.customer.debtorno, this.customer.branchcode).toPromise();

			if (results.success) {
				this.ngZone.runOutsideAngular(() => {
					this.cart_items = results.cart;

					// // Process each item outside Angular's zone
					// items.forEach((item) => {
					// 	if (parseFloat(item.quantity) != 0) {
					// 		const color = item.isnegative ? 'warn' : 'success';
					// 		this.ngZone.run(() => {
					// 			this.globalSearchService.showNotification(item.description + ' x ' + item.quantity + ' Added', color, 'bottom', 'left');
					// 		});
					// 	}
					// });

					// Update totals, run within Angular's zone since updateTotals contains UI updates
					this.ngZone.run(() => {
						this.updateTotals();
					});
				});
			} else {
				// UI update needs to be inside Angular's zone
				this.ngZone.run(() => {
					this.globalSearchService.showNotification(results.message, 'danger', 'bottom', 'left');
				});
			}

		} catch (error) {
			//console.error('Error adding items to order:', error);
			this.ngZone.run(() => {
				this.globalSearchService.showNotification('Failed to add items to order.', 'danger', 'bottom', 'left');
			});
		}
	}

	async removeFromOrder (cart_id: string): Promise < void > {
		try {
			// Optimistically remove the item from the cart before sending the request
			this.cart_items = this.cart_items.filter(item => item.cart_id !== cart_id);

			// Send the request to remove the item from the order
			const results = await this.orderService.removeFromOrder(cart_id, this.customer.debtorno, this.customer.branchcode).toPromise();

			// Update the cart items with the result from the service, if necessary
			this.cart_items = results;

			// Show notification
			this.globalSearchService.showNotification('Item Removed', 'danger', 'bottom', 'left');

			// Update totals
			this.updateTotals();

			// Send cart update
			this.sendCartUpdate();
		} catch (error) {
			// Handle errors here if needed
			console.error('Error removing item from order:', error);
		}
	}


	updatePrice(event: any, item: any) {
		if (event.target.value != '') {
			const index = this.cart_items.indexOf(item);
			const newPrice = parseFloat(event.target.value);
			if (!isNaN(newPrice)) {
				this.cart_items[index].price = newPrice;
				this.globalSearchService.showNotification(item.description + ' x ' + item.quantity + ' Updated', 'warning', 'bottom', 'left');
				this.updateCartItem(this.cart_items[index]);
			} else {
				this.globalSearchService.showNotification('Invalid price input', 'error', 'bottom', 'left');
			}
		}
	}


	updateCoupon() {
		const data = {
			debtorno: this.customer.debtorno,
			branchcode: this.customer.branchcode,
		}
		setTimeout(() => {


			this.couponService.getCartCouponValue(data).subscribe((result: any) => {
				this.cart_items.forEach(item => {

					if (item['stockid'] == 'COUPON')
					{
						const index = this.cart_items.indexOf(item);
						this.cart_items[index]['price'] = result.price;
					}

				});
			});
		}, 750);
	}

	updateQuantity(event: any, item: any) {
		if (event.target.value != '') {
			const index = this.cart_items.indexOf(item);
			const newQuantity = parseFloat(event.target.value);
			if (!isNaN(newQuantity)) {
				this.cart_items[index].quantity = newQuantity;
				this.globalSearchService.showNotification(item.description + ' x ' + item.quantity + ' Updated', 'warning', 'bottom', 'left');
				this.updateCartItem(this.cart_items[index]);
			} else {
				this.globalSearchService.showNotification('Invalid quantity input', 'error', 'bottom', 'left');
			}
		}
	}

	updateDiscount(event: any, item: any) {

		if (event.target.value != '') {
			const index = this.cart_items.indexOf(item);

			if (parseFloat(event.target.value) < 100) {} else {
				event.target.value = 100;
			}

			this.cart_items[index].discount = event.target.value;
			this.globalSearchService.showNotification(item.description + ' x ' + item.quantity + ' Updated', 'warning', 'bottom', 'left');
			this.updateCartItem(this.cart_items[index]);
		}

	}

	updateNote(event: any, item: any) {
		const index = this.cart_items.indexOf(item);
		this.cart_items[index].notes = event.target.value;
		this.updateCartItem(this.cart_items[index]);
	}

	getDiscounPrice(item: any) {
		const total = (item.price - (item.price * (item.discount / 100)));
		// if(total < 0) {
		// 	total = 0;
		// }
		return total;
	}

	getDiscountTotal(item: any) {
		const total = item.quantity * (item.price - (item.price * (item.discount / 100)));
		// if(total < 0) {
		// 	total = 0;
		// }
		return total;
	}

	updateCartItem(item: any) {
		if (typeof item === 'boolean') {
			this.updateCart(item);
			return;
		}
		if (!this.customer?.debtorno) {
			return;
		}

		const line =
			item?.cart_id != null && Array.isArray(this.cart_items)
				? this.cart_items.find((i: any) => String(i.cart_id) === String(item.cart_id))
				: null;
		const patch =
			item && typeof item === 'object'
				? Object.fromEntries(Object.entries(item).filter(([, v]) => v !== undefined))
				: {};
		const merged = line ? { ...line, ...patch } : item;
		if (merged?.cart_id == null) {
			return;
		}

		let optionPayload: any = merged.option;
		if (optionPayload == null || optionPayload === '') {
			optionPayload = merged.options;
		}
		const taxOverride =
			merged.taxdetails !== undefined && merged.taxdetails !== null
				? merged.taxdetails
				: merged.taxoveride;

		const data = {
			customer: this.customer.debtorno,
			branch: this.customer.branchcode,
			cartid: merged.cart_id,
			cart_id: merged.cart_id,
			price: merged.price,
			option: optionPayload != null ? optionPayload : '',
			quantity: merged.quantity,
			discount: merged.discount,
			notes: merged.notes != null ? merged.notes : '',
			stockid: merged.stockid,
			coupon_used: merged.coupon_used != null ? merged.coupon_used : '',
			editing_order: this.editing_order,
			order_details: this.order_details,
			taxoveride: taxOverride !== undefined ? taxOverride : null,
			description: merged.description != null ? merged.description : '',
		};

		this.orderService.updateOrder(data).subscribe((results: any) => {
			//holdover for multiplier
			if (this.config.env.package === 'tires') {
				this.updateChildren();
			}

			this.updateTotals();
			this.updateCoupon();
		});
	}

	//if input is not actually the child? cartid: any not sure this is appropriate..
	updateChildren() {
		this.cart_items.forEach((item: any) => {
			if (item.parent_id) {
				const parent = this.cart_items.find(i => i.cart_id === item.parent_id);
				if (parent) {
					item.quantity = parent.quantity;
				}
			}
		});
	}

	cartQtyReducer() {
		const tagalongs = this.tagalongs

		function reducer (accumulator: number, items: any) {
			let counter = 0;
			if (items.mbflag != 'F' && !(tagalongs).includes(items.stockid)) {
				counter = parseFloat(items.quantity);
			}
			return accumulator + counter;
		}
		return reducer
	}

	getTotal() {

		const total = this.cart_totals.filter(t => {
			return t.code == 'total';
		})[0]

		let value = 0.00;
		if (total) {
			value = parseFloat(parseFloat(total.text).toFixed(2))
		}

		return value;

	}

	checkCreditLimit() {
		if (this.checkCreditLimits === 0) { return; }
		if (!this.allowed_credit) {
			this.proceed = true;
		}
		this.overcredit = false;
		if (!Array.isArray(this.cart_totals)) { return; }
		const subtotal = this.cart_totals.filter(t => t.code === 'sub_total')[0];
		if (subtotal && this.customer?.credit_avail != null && parseFloat(subtotal.text) > this.customer.credit_avail) {
			this.overcredit = true;
		}
	}

	stopProp(event: any): void {
		event.stopPropagation();
	}

	sendCartUpdate() {

		if (this.user) {
			const data = [{ customer: this.customer.debtorno, user: this.user }]
			this.omsService.sendCartUpdate({ data, roomName: 'CartRoom' }, cb => {});
		}
	}

	toggleFlip() {

		switch (this.flip) {
		case 'inactive':
			this.flip = 'active';
			break;
		default:
			this.flip = 'inactive';
			break;
		}
	}

	ngOnInit(): void {
		this.globalsService.getCheckCreditLimits().subscribe(v => this.checkCreditLimits = v);
		this.getCustomerNotes();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.loadedOrder && this.loadedOrder && this.loadedOrder.header && this.customer) {
			this.applyLoadedOrder(this.loadedOrder);
		}

		if (changes && changes.customer && !this.custNotes.length) {
			this.getCustomerNotes();
		}

		this.updateCart();
	}

	emitCustomerUpdate(event: any) {
		this.invoicing = false;
		this.reloadCustomer.emit(event);
	}

	saveQuote() {

		if (this.editing_order) {
			this.editing_order = true;
			const continueconfirm = confirm('This is an open order, save as a quote and cancel order?');
			if (continueconfirm) {
				this.orderService.cancelOrder(this.order_details.header.orderno).subscribe((results: any) => {});
			} else {
				return false;
			}
		}

		this.orderService.saveQuote(this.customer, this.cart_items, this.cart_totals, this.user, this.customer_form.value).subscribe((result: any) => {
			this.globalSearchService.showNotification('Quote ' + result.orderno + ' Saved', 'success', 'bottom', 'left');
			this.reloadCustomer.emit(true)
			this.flip = 'inactive';
			this.orderDetails = false;
			this.resetOrder();
		});
	}

	refreshAvailability() {
		this.orderService.getCart(this.customer.debtorno, this.customer.branchcode).subscribe((items: any) => {
			if (items?.length) {
				this.cart_items = items;
				this.updateTotals();
				this.globalSearchService.showNotification('Availability refreshed', 'success', 'bottom', 'left');
			}
		});
	}

	clearCart() {
		this.orderService.clearOrder(this.customer.debtorno, this.customer.branchcode).subscribe((results: any) => {
			this.flip = 'inactive';
			this.updateCart();
		});
	}

	cancelOrder() {

		this.orderService.cancelOrder(this.order_details.header.orderno).subscribe((results: any) => {
			this.flip = 'inactive';
			this.invoicing = false;
			this.sending = false;
			this.orderResults = false;
			this.order_details = false;
			this.editing_order = false;
			this.customer.preselected = false;
			this.customer.dissallowinvoices = false;
			this.resetOrder();
			this.updateCart();
			//update sends
			const data = { user: this.user, }
			this.omsService.sendOrderPickUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});


		});
	}

	preauthandplaceOrder(){
		this.preauthorder = true;
		this.customer_form.get('preauth').setValue(this.preauthorder);
		this.placeOrder();
	}

	dropshipChangedProceed(){
		const dropshipvia_id = this.shippers['byname']['dropship'];
		const originalshipvia = this.customer.editingorder.shipvia
		const newshipvia = this.customer_form.value.defaultshipvia;

		let res = true;

		if(originalshipvia == dropshipvia_id && newshipvia != dropshipvia_id){
			res = confirm(`This was originally a dropship order, updating it to another delivery method will remove the associated purchase order and movements \n\nProceed?` )
			if(res){
				this.order_details['removedropship'] = true;
			}
		}
		return res;
	}

	placeOrder() {
		if (this.editing_order && this.order_details?.header?.tpl3pl_edit_locked) {
			this.applyTpl3plEditLockFromHeader(this.order_details.header);
			return;
		}
		if (this.customer_form?.get('preauth')) {
			const preauthCtrl = this.customer_form.get('preauth');
			const hasPaymentMethod = !!this.customer_form.get('payment_method')?.value;
			if (!hasPaymentMethod) {
				this.showpreauth = false;
				this.preauthorder = false;
				preauthCtrl.setValue(0, { emitEvent: false });
			} else {
				const fromUi = !!this.showpreauth || this.preauthorder;
				const pkg = this.config.env.package;
				const cardBackedPreauth =
					(pkg === 'tires' || pkg === 'beauty') && !!preauthCtrl.value;
				preauthCtrl.setValue(fromUi || cardBackedPreauth);
			}
		}
		this.checkCreditLimit();
		this.sending = true;
		this.globalSearchService.getFormValidationErrors(this.customer_form);
		this.customer_form.markAllAsTouched();

		if (this.checkCreditLimits !== 0 && this.overcredit) {
			this.globalSearchService.showNotification(
				this.creditHoldPreSubmitNotice,
				'warning',
				'bottom',
				'right'
			);
		}

		const refControl = this.customer_form.get('reference');
		const debtornoControl = this.customer_form.get('debtorno');
		const branchControl = this.customer_form.get('branchcode');

		const checkData = {
			reference: refControl?.value?.trim(),
			debtorno: debtornoControl?.value,
			branchcode: branchControl?.value,
			orderno: this.editing_order ? this.order_details?.orderno : null
		};
		
		this.orderService.checkForDuplicatePo(checkData, this.config.poDuplicateWarn).subscribe({
			next: (r: any) => {
				if (r.hault) {
					const confirmed = window.confirm(`${r.message}\n\nDo you want to proceed anyway?`);
					if (!confirmed) {
						this.sending = false;
						this.proceed = false;
						return;
					}

					this.customer_form.patchValue({ override: true });
				} else {
					this.proceed = true;
				}

				if (this.customer_form.valid && this.proceed) {
					const showReminder = this.config && this.config.paymentDueReminder === true;
					if (showReminder) {
						const code = this.customer_form.get('paymentterms')?.value;
						this.paymentDueTermsDescription = (this.terms && this.terms.find((t: any) => t.termsindicator === code)?.terms) ?? '';
						this.modalService.open(this.paymentDueReminderRef, { ariaLabelledBy: 'payment-due-reminder-title' }).result.then(
							() => this.proceedWithOrderSubmit(),
							() => { this.sending = false; }
						);
					} else {
						this.proceedWithOrderSubmit();
					}
				} else {
					this.sending = false;
				}
			},
			error: () => {
				this.sending = false;
			},
		});

		// this.updateCart()
	}

	private notifyCreditHoldAfterSubmit(results: { credit_hold?: boolean; credit_hold_message?: string }): void {
		if (!results?.credit_hold) {
			return;
		}
		this.globalSearchService.showNotification(
			results.credit_hold_message || this.creditHoldPostSubmitFallback,
			'warning',
			'bottom',
			'right'
		);
	}

	private applyTpl3plEditLockFromHeader(header: any): void {
		if (!header?.tpl3pl_edit_locked) {
			return;
		}
		this.proceed = false;
		const ono = String(header.orderno ?? '');
		if (this.lastTpl3plLockNoticeOrderno !== ono) {
			this.lastTpl3plLockNoticeOrderno = ono;
			this.globalSearchService.showNotification(
				header.tpl3pl_message || 'This order was dispatched to 3PL and cannot be edited.',
				'danger',
				'bottom',
				'right'
			);
		}
	}

	dismissPaymentDueReminder(modal: any) {
		modal.dismiss();
	}

	confirmPaymentDueReminder(modal: any) {
		modal.close();
	}

	proceedWithOrderSubmit() {
		if (!this.customer_form.valid || !this.proceed) {
			this.sending = false;
			return;
		}
		if (!this.editing_order) {
			const vform = this.vehicle_form?.value ?? {};
			if (this.config.env.package === 'tires') {
				const ep = this.usersService.usePrintConnect();
				this.user.usePrintConnect = ep;
			}
			const customerPayload = { ...this.customer_form.value, overcredit_override: this.overcredit_override };
			this.orderService.createOrder(customerPayload, this.cart_items, this.cart_totals, this.user, this.adjustment, vform).subscribe((results: any) => {
				this.sending = false;
				this.orderResults = results;
				const order_results = results;
				this.preauthorder = false;
				this.showpreauth = false;
				if (!results.success) {
					this.globalSearchService.showNotification(results.message, 'danger', 'bottom', 'right');
				}
				if (results.success) {
					this.notifyCreditHoldAfterSubmit(results);
				}
				if (this.user.usePrintConnect) {
					this.sendPrint(results.base64);
				}
				if (this.config.env.package === 'tires') {
					this.pickupAlert(results, this.customer_form.value);
				}
				this.flip = 'inactive';
				this.orderDetails = results;
				this.reloadCustomer.emit(results);
				this.editing_order = false;
				this.customer.preselected = false;
				this.orderService.clearOrder(this.customer.debtorno, this.customer.branchcode).subscribe((r: any) => {
					this.cart_items = [];
					this.total_cart_qty = 0;
					const data = { customerdata: this.customer_form.value, editing: false, neworder: true, orderdetails: order_results, user: this.user };
					this.omsService.sendOrderPickUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
				});
			}, (error: any) => {
				this.sending = false;
				console.error('Error creating order:', error);
			});
		} else {
			if (this.order_details?.header?.tpl3pl_edit_locked) {
				this.sending = false;
				this.applyTpl3plEditLockFromHeader(this.order_details.header);
				return;
			}
			const proceed = this.dropshipChangedProceed();
			if (!proceed) {
				this.sending = false;
				return;
			}
			const sendOrderPickUpdate$ = (data: any, roomName: string): Observable<any> => {
				return new Observable(observer => {
					this.omsService.sendOrderPickUpdate({ data, roomName }, (response: any) => {
						observer.next(response);
						observer.complete();
					});
				});
			};
			this.sending = true;
			const vform = this.vehicle_form?.value ?? {};
			if (this.config.env.package === 'tires') {
				const ep = this.usersService.usePrintConnect();
				this.user.usePrintConnect = ep;
			}
			const customerPayloadEdit = { ...this.customer_form.value, overcredit_override: this.overcredit_override };
			this.orderService.updateSalesOrder(
				customerPayloadEdit,
				this.cart_items,
				this.cart_totals,
				this.order_details,
				this.user,
				this.adjustment,
				vform
			).subscribe(
				(results: any) => {
					this.sending = false;
					this.preauthorder = false;
					this.showpreauth = false;
					if (!results.success) {
						this.globalSearchService.showNotification(results.message, 'danger', 'bottom', 'right');
						return;
					}
					this.notifyCreditHoldAfterSubmit(results);
					if (this.user.usePrintConnect && results.base64) {
						this.sendPrint(results.base64);
					}
					this.flip = 'inactive';
					this.orderResults = results;
					this.orderDetails = results;
					this.reloadCustomer.emit(results);
					forkJoin({
						clearOrder: this.orderService.clearOrder(this.customer.debtorno, this.customer.branchcode),
						orderPickUpdate: sendOrderPickUpdate$(
							{ customerdata: this.customer_form.value, editing: true, neworder: false, orderdetails: results, user: this.user },
							this.CHAT_ROOM
						)
					}).subscribe(
						({ clearOrder, orderPickUpdate }) => {
							this.cart_items = [];
							this.total_cart_qty = 0;
							this.editing_order = false;
							this.customer.preselected = false;
							this.customer.editingorder = false;
							if (this.config.scantotruck) {
								this.dispatchService.orderIsBeingLoaded({ orderno: results.orderno }).subscribe((r) => {
									if (r.dispatched) {
										sendOrderPickUpdate$({ customerdata: this.customer_form.value, orderdetails: results }, this.CHAT_ROOM).subscribe();
									}
								});
							}
						},
						(error) => console.error('Error processing order updates:', error)
					);
				},
				(error: any) => {
					this.sending = false;
					console.error('Error updating order:', error);
				}
			);
		}
	}

	sendPrint(data: any) {
		const type = 'INVOICE';
		const user = this.user.userid;
		const printers = this.usersService.getDevicesByType(user, type);
		
		// Check if data exists and is an array with content
		if (!data || !Array.isArray(data) || data.length === 0) {
			console.warn('sendPrint: No valid data provided or data is not an array');
			return;
		}
		
		if (printers && printers.length) {
			this.omsService.setNewOrder();
			data.forEach(doc => {
				const data = { pdf: doc, user: user, devices: printers }
				this.omsService.sendPrintCommand({ data, roomName: 'Printers' }, cb => {
					this.omsService.setPrintedOrder();
				})
			});
		}
	}


	pickupAlert(order, form){
		if(order.success && form.defaultshipvia == '2'){
			const data = {
				debtorno: form.debtorno + '.' + form.branchcode,
				order: order.orderno,
				name: form.brname
			}
			this.omsService.sendWillCallAlert({ data, roomName: 'truckalerts' }, cb => {});
		}
	}



	viewPurchOrderOptions(line: any) {
		line.allownegative = true;
		const data = { cart_id: line.cart_id, stockid: line.stockid }
		this.orderService.getPurchDataFromLine(data).subscribe((results: any) => {
			this.purchase_items.push(results);
			this.modalService.open(this.purchasedetails, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result: any) => {

			}, (reason) => {
				this.purchase_items = [];
			});
		});
	}



	itemSearch(item): any {
		const data = {
			keywords: item.inputValue,
			limit: 10,
			sort: 'SKU|ASC',
			customer: this.customer,
			filters: [],
			customer_items_only: false,
			vendor_items_only: false,
			type: '30',
			user: this.user.user
		};

		if (this.inventorysearching) {
			this.inventorysearching.unsubscribe();
		}

		this.inventorysearching = this.orderService.getItemSearch(data).subscribe((items: any) => {
			this.swapitems = items;
		});
	}

	selectSwapItem(item: any, fromitem: any) {
		const data = {
			cartid: fromitem.cartid,
			stockid: item.stockid,
			desription: item.description,
			price: item.price,
			quantity: fromitem.quantity
		}

		const updateitem = fromitem;

		updateitem.description = item.description;
		updateitem.stockid = item.stockid;
		updateitem.price = item.price;
		updateitem.quantity = fromitem.quantity;

		fromitem.inputValue = '';
		item.inputValue = '';
		item.switching = false;

		this.orderService.swapItem(data).subscribe((items: any) => {
			this.swapitems = false;
			this.updateCart(false);
		});

	}


	updateCart(inputflip = true) {
		if (this.fetchingCart) {
			this.fetchingCart.unsubscribe();
		}

		if (this.customer.debtorno) {
			this.gettingCart = true;
			this.fetchingCart = this.orderService.getCart(this.customer.debtorno, this.customer.branchcode).subscribe((items: any) => {

				const cart_items = items;
				if (inputflip) {
					if (items.length) {
						this.flip = 'active';
					}
				}
				//current cart tied to a sales order - user loaded an order and left
				const hasorderno = items.map(item => { return (item.orderno != 0) ? item.orderno : false })[0];

				//todo rework this - doubles up on the calls
				if (hasorderno && !this.order_details.header) {

					this.orderService.isPreOrder(hasorderno).subscribe((r: any) => {

						if (r.ispo) {
							this.clearCart();
							this.orderService.loadPreOrder(hasorderno, false, false).subscribe((results: any) => {
								const { header, preselected, cart } = results;

								// Set editing_order and customer.editingorder
								this.editing_order = true;
								this.customer.editingorder = header;

								// Set preselected and order_details
								this.customer.preselected = preselected;
								this.order_details = results;
								this.adjustment.additionalcharge = this.order_details.header.additionalcharge;
								this.adjustment.additionaltext = this.order_details.header.additionaltext;

								// Set cart_items
								this.cart_items = cart;

								// Update flip based on cart length
								this.flip = cart.length > 0 ? 'active' : '';

								// Update payments
								this.updatePayments(false);
							});
						} else {

							this.orderService.loadSalesOrder(hasorderno).subscribe((results: any) => {
								const { header, preselected, cart } = results;

								// Only proceed if header is valid
								if (header) {
									// Set editing_order and customer.editingorder
									this.editing_order = true;
									this.customer.editingorder = header;

									// Set preselected and order_details
									this.customer.preselected = preselected;
									this.order_details = results;

									//set vehicle form
									this.vehicle_form = header.vehicle;


									// Set adjustment fields
									const { additionalcharge, additionaltext } = header;
									this.adjustment = { additionalcharge, additionaltext };

									// Set cart_items
									this.cart_items = cart;

									// Update flip based on cart length
									this.flip = cart.length > 0 ? 'active' : '';

									// Update payments
									this.updatePayments(false);
								}
							});

						}

					});

				} else {
					this.cart_items = items;
					this.adjustment.additionalcharge = 0.00;
					this.adjustment.additionaltext = '';
					const fromquote = items.map((i) => { return i.quoteno })[0];

					if (fromquote !== '' && fromquote && fromquote !== 0 && fromquote !== '0') {

					this.orderService.loadQuote(fromquote).subscribe((r: any) => {
						const header = r.header;
						if (header) {
							const { shipvia, freightcost, comments, notes } = header;
							const defaultShipViaControl = this.customer_form.get('defaultshipvia');
							const freightCostControl = this.customer_form.get('freightcost');
							const commentsControl = this.customer_form.get('comments');
							const notesControl = this.customer_form.get('notes');
							const refControl = this.customer_form.get('reference');


							if (defaultShipViaControl && shipvia) {
								defaultShipViaControl.setValue(shipvia);
							}
							if (freightCostControl && freightcost) {
								freightCostControl.setValue(freightcost);
								this.updateShipping(freightcost);
							}
							if (commentsControl && comments) {
								commentsControl.setValue(comments);
							}

							if (refControl && header?.customerref) {

								refControl.setValue(header.customerref);
							}

							if (notesControl && notes) {
								notesControl.setValue(notes);
							}

							this.cart_items = r.cart;

							// Refresh cart from main getCart to get live qoh/stock after quote load
							this.orderService.getCart(this.customer.debtorno, this.customer.branchcode).subscribe((liveItems: any) => {
								if (liveItems?.length) {
									this.cart_items = liveItems;
									this.updateTotals();
								}
							});
						}
					});

					}
				}

				this.gettingCart = false;

				this.updateTotals();
			});
		}
	}

	getItemDiscountMultiplier(item) {
		if (!isNaN(this.financial(item.discount))) {
			return this.financial(item.discount / 100);
		}
		return 0;
	}



	editOrder(orderno: any) {
		this.sending = false;
		this.orderResults = false;
		this.lastTpl3plLockNoticeOrderno = null;
		this.orderService.loadSalesOrder(orderno).subscribe((results: any) => {

			this.editing_order = true;
			this.order_details = results;
			this.adjustment.additionalcharge = this.order_details.header.additionalcharge;
			this.adjustment.additionaltext = this.order_details.header.additionaltext;
			this.customer.preselected = results.preselected;

			this.fetchingCart = this.orderService.getCart(results.header.debtorno, results.header.branchcode).subscribe(async (items: any) => {

				this.editing_order = true;
				this.order_details = results;

				this.cart_items = items;
				this.customer.editingorder = results.header
				this.customer.preselected = results.preselected;

				if (items.length) {

					if (!items[0].override || items[0].override == '') {
						//order was not flagged - do not stop it
						this.proceed = true;
						this.allowed_credit = true;
						this.overcredit_override = items[0].override
					}
				}

				this.applyTpl3plEditLockFromHeader(results.header);
				this.updateTotals();
				this.updatePayments(false);
			});

			this.flip = 'active';
		})
	}

	//deposits
	updatePayments(event: any) {

		if (event) {
			this.payments_added = event;
			this.payment_total = this.payments_added.reduce(function(accumulator, item) {
				return parseFloat(accumulator) + parseFloat(item.amount);
			}, 0);
		}

		const data = {
			orderno: (this.order_details) ? this.order_details.header.orderno : '1',
			debtorno: this.customer.debtorno,
			branchcode: this.customer.branchcode,
		}

		this.paymentsService.getOrderPayments(data).subscribe((results: any) => {
			this.payments = results;
			this.updateTotals()

			this.payment_total = this.financial(results.reduce(function(accumulator, item) {
				return parseFloat(accumulator) + parseFloat(item.amount);
			}, 0));

		});

	}

	financial(num: number): number {
		const rounded = Math.round((num + Number.EPSILON) * 100) / 100; // Rounding to 2 decimal places again
		return parseFloat(rounded.toFixed(2));
	}

	branchchange(event){
		this.branchupdating = event;
	}


	openPreOrder() {
		this.modalService.open(this.preorderRef, { ariaLabelledBy: 'modal-title', size: 'l' }).result.then((result: any) => {}, (reason) => {

		});
	}

	placePreOrder(cont: boolean) {
		this.modalService.dismissAll();
		if (cont) {

			const preorder = {
				status: true,
				date: this.preorderDate.value ?? new Date()
			};

			this.orderService.createPreOrder(this.customer_form.value, this.cart_items, this.cart_totals, this.user, preorder)
				.subscribe((results: any) => {
					this.sending = false;
					this.orderResults = results;
					this.flip = 'inactive';
					this.orderDetails = results;
					this.reloadCustomer.emit(results);
					this.editing_order = false;
					this.customer.preselected = false;

					this.orderService.clearOrder(this.customer.debtorno, this.customer.branchcode)
						.subscribe(() => {
							this.cart_items = [];
							this.total_cart_qty = 0;
							const data = {
								customerdata: this.customer_form.value,
								editing: false,
								neworder: true,
								orderdetails: results,
								user: this.user
							};

							this.omsService.sendOrderPickUpdate({ data, roomName: this.CHAT_ROOM }, () => {});
							// this.router.navigate(['/orders/invoice/' + this.orderResults.orderno]);
						});
				})
		};
	}

	selectCustomer(customer: any) {

		const data = { to: customer, from: this.customer }
		this.orderService.changeOrderCustomer(data).subscribe((results: any) => {
			this.modalService.dismissAll();
			this.customer_updated.emit(customer);
			this.router.navigate(['./orders/entry/' + customer.debtorno + '/' + customer.branchcode]);
		});
	}

	openChangeCustomer() {
		this.modalService.open(this.changeCustomerRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
	}

	getCustomerNotes() {
		if (this.customer?.debtorno) {
			const data = {
				debtorno: this.customer.debtorno,
				branch: this.customer.branchcode
			};

			if (this.customerNotesSubscription) {
				this.customerNotesSubscription.unsubscribe();
			}

			this.customerNotesSubscription = this.customerService.getCustomerNotes(data).pipe(
				take(1)
			).subscribe(notes => {
				this.custNotes = notes.filter(note => note.note_code.toUpperCase() === 'ORDER');
			});
		}
	}
	editNote(note: any) {
		note.isEditing = !note.isEditing;
	}

	deleteNote(note: any) {
		this.custNotes = this.custNotes.filter(n => n !== note);
	}

	validateDate(event: any) {
		const newDate = new Date(event);
		const now = new Date();

		// Create new dates with only the year, month, and day components
		const formattedNow = new Date(now.getFullYear(), now.getMonth(), now.getDate());
		const formattedNew = new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());

		if (formattedNow.getTime() <= formattedNew.getTime()) {
			this.preorderDate.value = newDate;
			this.preorderDate.status = true;
		} else {
			this.preorderDate.value = 'Pre-Order date has to be a future date.';
			this.preorderDate.status = false;
		}
	}

	openTrackingNumberAssign() {
		this.modalService.open(this.assignTrackingRef, { ariaLabelledBy: 'modal-title', size: 'lg', backdrop: 'static' }).result.then((result) => {}, (reason) => {

		});
	}

	ngOnDestroy() {
		if (this.worker) {
			this.worker.terminate();
		}

		//this.resetOrder();
	}

	showLocQoh(locations: any): number | undefined {
		if (Array.isArray(locations) && locations.length) {
			const loc = locations.find((l) => l?.loccode === this.user?.defaultlocation?.loccode);
			return loc?.quantity;
		}
		return 0;
	}


	showpreAuth(event){
		this.showpreauth = event;
		this.preauthorder = !!event;
		if (this.customer_form?.get('preauth')) {
			this.customer_form.get('preauth').setValue(this.preauthorder, { emitEvent: false });
		}
	}

}